import type { RSheetRecordNode } from '../../../../domain/column'
import type { SetMainCursorByRecordIdArguments } from '../../../hooks/useSetMainCursorByRecordId'

export const openContextMenu = ({
  rootRecordNode,
  columnIndex,
  innerRowIndex,
  contextMenuPosition,
  disabled,
  setMainCursorByRecordId,
}: {
  rootRecordNode: RSheetRecordNode
  columnIndex: number
  innerRowIndex: number
  contextMenuPosition: { x: number; y: number }
  disabled: boolean
  setMainCursorByRecordId: (arguments_: SetMainCursorByRecordIdArguments) => void
}): void => {
  if (rootRecordNode.id === undefined) {
    return
  }
  setMainCursorByRecordId({
    position: {
      recordId: rootRecordNode.id,
      columnIndex,
      innerRowIndex,
    },
    option: {
      expand: false,
      contextMenuPosition,
      disabled,
      keepExpand: true,
    },
  })
}

export const toggleEditMode = ({
  rootRecordNode,
  columnIndex,
  innerRowIndex,
  disabled,
  setMainCursorByRecordId,
}: {
  rootRecordNode: RSheetRecordNode
  columnIndex: number
  innerRowIndex: number
  disabled: boolean
  setMainCursorByRecordId: (arguments_: SetMainCursorByRecordIdArguments) => void
}): void => {
  if (rootRecordNode.id === undefined) {
    return
  }
  setMainCursorByRecordId({
    position: {
      recordId: rootRecordNode.id,
      columnIndex,
      innerRowIndex,
    },
    option: {
      expand: false,
      toggle: true,
      disabled,
    },
  })
}

export const setEditMode = ({
  rootRecordNode,
  columnIndex,
  innerRowIndex,
  disabled,
  setMainCursorByRecordId,
}: {
  rootRecordNode: RSheetRecordNode
  columnIndex: number
  innerRowIndex: number
  disabled: boolean
  setMainCursorByRecordId: (arguments_: SetMainCursorByRecordIdArguments) => void
}): void => {
  if (rootRecordNode.id === undefined) {
    return
  }
  setMainCursorByRecordId({
    position: {
      recordId: rootRecordNode.id,
      columnIndex,
      innerRowIndex,
    },
    option: {
      expand: false,
      isEditing: true,
      disabled,
    },
  })
}
